import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { MapPin, ChevronRight } from 'lucide-react';
import SEOHead from '@/components/marketplace/SEOHead';

const LocationsDirectory = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/location-pages')
      .then((r) => setPages(r.data || []))
      .catch(() => setPages([]))
      .finally(() => setLoading(false));
  }, []);

  const canonical = typeof window !== 'undefined' ? `${window.location.origin}/locations` : undefined;

  return (
    <div className='indus-container py-8' data-testid='locations-directory'>
      <SEOHead
        title='Industrial Equipment Locations Over India | Indus Fact'
        description='Browse IndusFact listings by city. Find surplus machinery, tools & equipment for sale near you, from Delhi and Mumbai to Surat, Chennai & beyond.'
        canonical={canonical}
        robots='index,follow'
      />
      <div className='max-w-2xl'>
        <h1 className='text-3xl sm:text-4xl font-semibold tracking-tight'>Browse by Location</h1>
        <p className='mt-2 text-muted-foreground'>
          Find industrial machines, equipment, spare parts and services from verified suppliers across India’s major manufacturing hubs.
        </p>
      </div>

      {loading ? (
        <div className='py-16 text-center text-muted-foreground'>Loading locations…</div>
      ) : pages.length === 0 ? (
        <div className='py-16 text-center text-muted-foreground'>Location pages are coming soon.</div>
      ) : (
        <div className='mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4' data-testid='locations-grid'>
          {pages.map((p) => (
            <Link key={p.id} to={`/locations/${p.slug}`} data-testid={`location-card-${p.slug}`}>
              <Card className='p-5 h-full hover:shadow-md hover:border-primary/40 transition-all flex items-center justify-between gap-3'>
                <div className='flex items-center gap-3 min-w-0'>
                  <span className='rounded-lg bg-secondary p-2.5 shrink-0'><MapPin className='h-5 w-5 text-primary' /></span>
                  <div className='min-w-0'>
                    <div className='font-semibold truncate'>{p.city}</div>
                    <div className='text-xs text-muted-foreground truncate'>
                      {p.state} · {p.listing_count || 0} listing{(p.listing_count || 0) === 1 ? '' : 's'}
                    </div>
                  </div>
                </div>
                <ChevronRight className='h-4 w-4 text-muted-foreground shrink-0' />
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default LocationsDirectory;
